/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
module platform {
   export class CurrentObjectService {
      static $inject = ["$injector"];
      private service: CurrentObjectService;

      constructor(private $injector:any) {
      }

      // Using the late-binding pattern to get the service from the
      // injector only when its called for usage the first time.
      // Could have called this in the constructor to set up the class
      // but due to timing difference of ng1 and ng5, lets use this
      // late-binding pattern.
      private get vcCurrentObjectService(): CurrentObjectService {
         if (!this.service) {
            this.service = this.$injector.get('vcCurrentObjectService');
         }
         return this.service;
      }

      getObjectId(): string | null {
         return this.vcCurrentObjectService.getObjectId();
      }
   }

   /**
    * @ngdoc service
    * @name com.vmware.platform.ui.currentObjectService
    * @module com.vmware.platform.ui
    *
    * @description
    *    Utility methods for fetching data from the /data endpoint.
    */
   angular.module("com.vmware.platform.ui").service("currentObjectService", CurrentObjectService);
}
